import { map } from 'rxjs/operators';
import { lastValueFrom, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { APP_CONFIG, AppConfig } from '@app/app.config';
import { ChangePasswordViewModel, ResetAccountViewModel, SetNewPasswordViewModel, UserViewModel } from '@circlon/operate-api-model';

@Injectable()
export class AccountService {
  private baseUrl = `${this.appConfig.apiBaseEndpoint}v1.0/account`;

  constructor(private httpClient: HttpClient, @Inject(APP_CONFIG) private appConfig: AppConfig) {}

  getCurrentUser$(): Observable<UserViewModel> {
    const url = `${this.baseUrl}/getcurrentuser`;
    return this.httpClient.get<UserViewModel>(url).pipe(map(res => UserViewModel.fromJS(res)));
  }

  resetAccount$(model: ResetAccountViewModel) {
    const url = `${this.baseUrl}/resetaccount`;
    return this.httpClient.post<null>(url, model);
  }

  changePassword(model: ChangePasswordViewModel) {
    const url = `${this.baseUrl}/changepassword`;
    return lastValueFrom(this.httpClient.post<null>(url, model));
  }

  changePassword$(model: ChangePasswordViewModel) {
    const url = `${this.baseUrl}/changepassword`;
    return this.httpClient.post<void>(url, model);
  }

  setNewPassword$(model: SetNewPasswordViewModel) {
    const url = `${this.baseUrl}/setpassword`;
    return this.httpClient.post<null>(url, model);
  }

  updateLanguage(languageCode: string): Promise<UserViewModel> {
    const url = `${this.baseUrl}/updateLanguage/${languageCode}`;
    return lastValueFrom(this.httpClient.post<UserViewModel>(url, {})).then(res => UserViewModel.fromJS(res));
  }
}
